import React, { Component } from "react";
import { Row, Card, CardBody, CardTitle, Button } from "reactstrap";
import ReactTable from "react-table";
import { withTranslation } from "react-i18next";
import { Colxx } from "../components/common/CustomBootstrap";
import { reactTableText } from "../constants/configs";
import Api from "../services/Api";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { getDatePickerProps } from "../helpers/Utils";
import i18n from "../services/i18n";
import fa_IR from "../constants/locales";
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import { Input } from "@material-ui/core";

class WalletHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      walletHistory: [],
      loading: false,
      page: 0,
      pageSize: 5,
      fetched: false,
      selectedDate: new Date(),
    };
  }

  componentDidMount() {
    this.onLoadData(0, this.state.pageSize);
  }

  onLoadData = async (page = 0, pageSize = this.state.pageSize) => {
    this.setState({ loading: true, fetched: true });

    try {
      const formattedDate = this.state.selectedDate.toISOString();

      const { data } = await Api.invoke(
        "GET",
        "/v2/admin-ui/users/timed-wallet",
        null,
        {
          params: {
            userId: this.props.userId,
            date: formattedDate,
          },
        }
      );

      const walletHistoryArray = Object.entries(data).map(
        ([currency, amount]) => ({
          currency,
          amount,
        })
      );

      this.setState({
        walletHistory: walletHistoryArray,
        loading: false,
        page,
        pageSize,
      });
    } catch (error) {
      console.error("Failed to load wallet history", error);
      this.setState({ loading: false });
    }
  };

  handlePageChange = (page) => {
    this.setState({ page });
  };

  handlePageSizeChange = (newPageSize, newPage) => {
    this.setState({ pageSize: newPageSize, page: newPage });
  };

  getColumns = (t) => [
    {
      Header: t("Currency"),
      accessor: "currency",
      width: 150,
    },
    {
      Header: t("Amount"),
      accessor: "amount",
      width: 200,
      Cell: ({ value }) =>
        typeof value === "number" ? value.toFixed(6) : value,
    },
  ];

  render() {
    const { t } = this.props;
    const { walletHistory, loading, page, pageSize, selectedDate, fetched } =
      this.state;

    // Sort by amount descending
    const sortedData = [...walletHistory].sort((a, b) => b.amount - a.amount);

    return (
      <MuiPickersUtilsProvider
        utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
        locale={i18n.language}
      >
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex justify-content-between align-items-center">
                  {t("Wallet History")}
                  <div className="flex items-center space-x-4">
                    <DateTimePicker
                      {...getDatePickerProps()}
                      value={selectedDate}
                      TextFieldComponent={(props) => (
                        <Input
                          className="w-36 px-2 py-1 text-xs border border-gray-300"
                          placeholder={i18n.t("Date")}
                          {...props}
                        />
                      )}
                      onChange={(date) => {
                        this.setState({ selectedDate: date, page: 0 }, () => {
                          this.onLoadData(0, pageSize);
                        });
                      }}
                    />

                    <Button
                      onClick={() => this.onLoadData(page, pageSize)}
                      disabled={loading}
                      className="ml-4"
                    >
                      {loading ? t("Loading...") : t("Load Data")}
                    </Button>
                  </div>
                </CardTitle>

                {fetched && (
                  <ReactTable
                    className="-highlight"
                    data={sortedData} // full data, ReactTable handles pagination
                    loading={loading}
                    sortable={false}
                    resizable
                    page={page}
                    pageSize={pageSize}
                    onPageChange={this.handlePageChange}
                    onPageSizeChange={this.handlePageSizeChange}
                    columns={this.getColumns(t)}
                    defaultPageSize={pageSize}
                    style={{ width: "100%" }}
                    {...reactTableText}
                  />
                )}
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </MuiPickersUtilsProvider>
    );
  }
}

export default withTranslation()(WalletHistory);
